/**
 * Renderers Markdown compartidos del chat.
 *
 * ReactMarkdown solo soporta CommonMark estricto: sin `remark-gfm` las
 * tablas del LLM se renderizan como texto plano con barras `|`. Con el
 * plugin ya las parsea, pero la `prose` de Tailwind no las estiliza por
 * defecto; estos renderers les dan el look del design system.
 */
import type { Components } from "react-markdown";

export const tableComponents: Components = {
  // Wrapper con scroll horizontal: si el LLM devuelve una tabla más
  // ancha que la columna del chat, scrollea dentro sin romper layout.
  table: ({ children }) => (
    <div className="my-3 overflow-x-auto rounded border border-line">
      <table className="w-full border-collapse text-xs">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-surface-100">{children}</thead>,
  tr: ({ children }) => (
    <tr className="border-b border-line last:border-0 even:bg-surface-100/50">
      {children}
    </tr>
  ),
  th: ({ children }) => (
    <th className="px-3 py-2 text-left font-heading font-semibold text-ink">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="px-3 py-2 align-top text-content">{children}</td>
  ),
};
